export const updateSubscriberLink = (data = {}) => {
  if (document.getElementById('lms-subscriber') !== null) {
    const subscriberMessage = {
      id: 'update.subscriberLink',
      messageData: { ...data },
    };
    window.postMessage(subscriberMessage);
  }
};
